// src/components/forms/mapping-editor/AggregatedTextFieldsEditor.tsx (Create this file)
import React, { useCallback } from 'react';
import { SimpleListEditor } from './SimpleListEditor';
import { AggregatedTextField } from '../../../../interfaces/dynamicForms/PdfMapping';
import FormInput from '../formBuilder/FormInput';

interface AggregatedTextFieldsEditorProps {
  aggregations: AggregatedTextField[] | undefined;
  updateAggregations: (newAggregations: AggregatedTextField[]) => void;
}

const AggregatedTextFieldsEditor: React.FC<AggregatedTextFieldsEditorProps> = ({ aggregations, updateAggregations }) => {

  // Function to render the inputs for a single AggregatedTextField item
  const renderAggregationItem = useCallback((
    item: AggregatedTextField,
    index: number,
    onChange: (index: number, updatedItem: AggregatedTextField) => void
  ) => {
    const handleItemInputChange = (field: keyof AggregatedTextField, value: string) => {
      onChange(index, { ...item, [field]: value });
    };

    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <FormInput
          label="Form Field Prefix"
          id={`agg-prefix-${index}`}
          value={item.Prefix || ''}
          onChange={(e) => handleItemInputChange('Prefix', e.target.value)}
          placeholder="e.g., comment_"
          required
        />
        <FormInput
          label="Target PDF Field Name"
          id={`agg-pdfField-${index}`}
          value={item.PdfField || ''}
          onChange={(e) => handleItemInputChange('PdfField', e.target.value)}
          placeholder="e.g., CommentsTextField"
          required
        />
        <FormInput
          label="Separator (use \n for newline)"
          id={`agg-separator-${index}`}
          value={item.Separator ?? ''} // Use ?? to handle potential null from JSON
          onChange={(e) => handleItemInputChange('Separator', e.target.value)}
          placeholder="Default: \\n\\n (two newlines)" // Show effective default
        />
      </div>
    );
  }, []);

  // Function to create a new, empty AggregatedTextField item
  const createDefaultAggregationItem = useCallback((): AggregatedTextField => {
    // Default separator matches service logic if empty/null in JSON
    return { Prefix: '', PdfField: '', Separator: '\n\n' };
  }, []);

  return (
    <SimpleListEditor
      items={aggregations}
      updateItems={updateAggregations}
      renderItem={renderAggregationItem}
      createDefaultItem={createDefaultAggregationItem}
      title="Aggregated Text Fields"
      itemTitle="Aggregation Rule"
      addButtonText="Add Aggregation Rule"
    />
  );
};

export default AggregatedTextFieldsEditor;